import { memo, useState } from "react";
import Demo from "./Demo/Demo";
import Name from "./Name/Name";
import Highlight from "./Highlight/Highlight";
import { FailureRating } from "@coworker/apprestructured/src/shared/components/FailureRating/FailureRating";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import Actions from "./Actions/Actions";

function FailureRatingDemo() {
  const [failedCriteria, setFailedCriteria] = useState(4);
  const [maxCriteria, setMaxCriteria] = useState(6);

  return (
    <Demo>
      <Name>Failure rating</Name>
      <Highlight>
        <FailureRating
          failedCriteria={failedCriteria}
          maxCriteria={maxCriteria}
          message="criteriaFailedString"
        />
      </Highlight>

      <Actions>
        <FixaInputField
          id="failureratingdemo-failedCriteria"
          value={failedCriteria as unknown as string}
          onChange={(e) => setFailedCriteria(parseInt(e.target.value) || 0)}
          type="number"
          min="0"
          max="100"
          label="failedCriteria"
        />

        <FixaInputField
          id="failureratingdemo-maxCriteria"
          value={maxCriteria as unknown as string}
          onChange={(e) => setMaxCriteria(parseInt(e.target.value) || 0)}
          type="number"
          min="0"
          max="100"
          label="maxCriteria"
        />
      </Actions>
    </Demo>
  );
}

export default memo(FailureRatingDemo);
